<template>
  <div class="map-container">
    <HereMap />
  </div>
</template>
<script>
import HereMap from '@common/components/map/HereMap';

export default {
  components: {
    HereMap,
  },
};
</script>
<style>
  .map-container {
    height: 500px;
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
  }
  </style>
